
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';

type IncidenceResolutionRecord = {
  type?: string;
  actionType?: string;
};

type Props = {
  record: IncidenceResolutionRecord;
};

const TYPE_COLOR: Record<string, 'primary' | 'info' | 'success' | 'warning' | undefined> = {
  REFUND: 'primary',
  EXCHANGE: 'warning',
  REPLACEMENT: 'info',
};

const IncidenceResolutionCell = ({ record: data }: Props) => {
  const { t } = useTranslation('incidenceResolution');
  const resolutionType = data?.type || data?.actionType || '';

  return (
    <Chip
      label={t(`solution.${resolutionType}`)}
      size={'small'}
      // @ts-ignore
      color={TYPE_COLOR[resolutionType]}
      sx={{ '&:hover': { backgroundColor: TYPE_COLOR[resolutionType] } }}
    />
  );
};

export default memo(IncidenceResolutionCell);
